import type { BookingRecord } from '../../../../types'

type CustomerCellProps = {
  customer: BookingRecord['customer']
}

export const CustomerCell = ({ customer }: CustomerCellProps) => (
  <div className="flex flex-col items-start gap-[4px] px-[4px] font-host font-normal leading-normal">
    <span className="truncate text-[16px] text-black">{customer.name}</span>
    {/* <span className="truncate text-[14px] text-dash-cell-muted">{customer.email}</span> */}
  </div>
)
